module.exports = __webpack_public_path__ + "static/media/_ME10767.6ff9c62a.jpg";